export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5289.c8509e79.jpg";